module.exports = __webpack_public_path__ + "static/media/MaSanteNB-Logo.3db82b15.png";